// PassageVerificationRequest.
//
// Class representing a passage verification request.
export class PassageVerificationRequest {
  public passageWaveformId: number;
  public isVerified: boolean;

  public constructor(passageWaveformId: number, isVerified: boolean) {
    this.passageWaveformId = passageWaveformId;
    this.isVerified = isVerified;
  }
}
